import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    schema: {
      title: 'Schema',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
